import {action, observable} from "mobx";
import GlobalStore from '@/store/GlobalStore';
import log from '@/utils/log';
const {DetectRTC} = window as any

import {
  getPolicyDot, getCloudDeviceList, cloudDevicePlay,
  cloudDeviceRename, cloudDeviceReboot, cloudDeviceReset, cloudDeviceRefresh,uaBlackList
} from '@/services/home';

import router from '@/router';

export enum ModalStateName {
  deviceNumberModalState = 'deviceNumberModalState',
  renameModalState = 'renameModalState',
  restoreModalState = 'restoreModalState',
  restartModalState = 'restartModalState',
  signoutModalState = 'signoutModalState',
  webRTCModalState = 'webRTCModalState'
}

class HomeStore {

  // 抽屉状态
  @observable drawerVisible = false;

  @observable saleCardInfo = {
    name: '打折卡',
    number: 0,
    showDot: false,
    click: () => GlobalStore.toast.text('请在app中使用')
  }

  @observable couponInfo = {
    name: '代金券',
    number: 0,
    showDot: false,
    click: () => GlobalStore.toast.text('请在app中使用')
  }

  @observable pointCardInfo = {
    name: '激活码',
    number: 0,
    showDot: false,
    click: () => GlobalStore.toast.text('请在app中使用')
  }

  @observable messageInfo = {
    number: 0,
    showDot: false
  }

  // 云手机列表
  @observable cloudDeviceList

  // 设备播流信息
  @observable cloudDevicePlayInfo: any = window.localStorage.getItem('cloudDevicePlayInfo') ? JSON.parse(window.localStorage.getItem('cloudDevicePlayInfo') || '') : {}

  @observable activeIndex = 0

  @observable renameText = ''

  // 设备号弹窗状态
  @observable deviceNumberModalState = false

  // 重命名弹窗状态
  @observable renameModalState = false

  // 恢复出厂弹窗状态
  @observable restoreModalState = false

  // 重启弹窗状态
  @observable restartModalState = false

  // 退出弹窗状态
  @observable signoutModalState = false

  // webrtc弹窗状态
  @observable webRTCModalState = false

  @observable uaBlackList = []

  @observable isWebRTCSupported = true

  @action.bound testingWebRTC() {
    DetectRTC.load(() =>{
      this.isWebRTCSupported = DetectRTC.isWebRTCSupported
    })
  }

  @action.bound async uaBlackListRequest () {
    const response = await uaBlackList()
    if (response.code === 10000) {
      this.uaBlackList = response.result.list
    }
  }

  // 开启抽屉
  @action.bound drawerShow() {
    this.drawerVisible = true
  }

  // 隐藏抽屉
  @action.bound drawerHide() {
    this.drawerVisible = false
  }

  @action.bound routerPushCustomer() {
    router.push({path: 'customer'})
  }

  @action.bound routerPush(name: string) {
    router.push({path: name})
  }

  @action.bound signout() {
    this.drawerVisible = false;
    this.deviceNumberModalState = false
    this.renameModalState = false
    this.restoreModalState = false
    this.restartModalState = false
    this.signoutModalState = false
    document.cookie = `auth_info=null`
    router.push({path: '/'})
  }

  // 获取小红点数据
  @action.bound async getPolicyDot() {

    const response = await getPolicyDot();

    if(response.code === 10000) {

      this.couponInfo = Object.assign({}, this.couponInfo, {
        number: response.result.coupon_info.count,
        showDot: response.result.coupon_info.is_show === 1 ? true : false
      })

      this.saleCardInfo = Object.assign({}, this.saleCardInfo, {
        number: response.result.sale_card_info.count,
        showDot: response.result.sale_card_info.is_show === 1 ? true : false
      })

      this.pointCardInfo = Object.assign({}, this.pointCardInfo, {
        number: response.result.point_card_info.count,
        showDot: response.result.point_card_info.is_show === 1 ? true : false
      })

      this.messageInfo = Object.assign({}, {
        number: response.result.message_info.count,
        showDot: response.result.message_info.is_show === 1 ? true : false
      })

      return false
    }

  }

  // 获取云手机列表
  @action.bound async getCloudDeviceList() {

    const response = await getCloudDeviceList();
    if(response.code === 10000) {
      this.cloudDeviceList = response.result.cloud_device_list.map(r => ({
        id: r.id,
        cid: r.cid,
        canRenew: r.can_renew,
        title: r.title,
        screenImageUri: r.screen_image_uri,
        status: r.status,
        deviceType: r.device_type,
        remainTime: r.remain_time,
        refreshStatus: false,
        category: r.category,

      }))
      setInterval(() => {
        this.cloudDeviceList = this.cloudDeviceList.map(r => ({
          ...r,
          remainTime: r.remainTime - 60
        }))
      }, 1000 * 60)
      return false;
    }

  }

  // 设置对话框状态
  @action.bound setModalState(name: ModalStateName, state: boolean) {
    if(name === ModalStateName.renameModalState) {
      const {title} = this.getActiveData()
      if (state === true) {
        this.renameText = title
      }
    }
    this[name] = state;
  }

  @action.bound testingDevice (id: number) {

    const activeDevice = this.cloudDeviceList.filter(item => item.id === id)[0]
    const oldDeviceTypeList = ['','RK3288','MTK8693','QCOM_SDM845','QCOM_QCS8250']
    const newDeviceTypeList = ['', 'g1','g2','g3','g4']
    const specName = activeDevice.specName
    let generation
    if (oldDeviceTypeList.indexOf(specName) ) {
      generation = oldDeviceTypeList.indexOf(specName)
    } else {
      generation = newDeviceTypeList.indexOf(specName.split('-')[1])
    }

    /* 非一代设备时候使用webrtc播流 */
    if (generation !== 1) {
      /* 检测黑名单 */
      let isBlack = false;
      this.uaBlackList.map ((item: {uaBlack: string}) => {
        if (window.navigator.userAgent.indexOf(item.uaBlack) !== -1) {
          isBlack = true
        }
      })
      if (isBlack) {
        this.setModalState(ModalStateName.webRTCModalState, true)
        return false
      }
      /* webrtc检测 */
      if (this.isWebRTCSupported === false) {
        this.setModalState(ModalStateName.webRTCModalState, true)
        return false
      }
    }
    return true
  }

  // 云手机播流
  @action.bound async cloudDevicePlay(id: number, deviceType: number) {

    const state = this.testingDevice(id)
    if (!state) return
    const response = await cloudDevicePlay({userItemId: id})
    this.getActiveData()
    if(response.code === 10000) {
      this.cloudDevicePlayInfo = {
        cid: response.result.cid,
        accessToken: response.result.access_token,
        pkgName: this.getActiveData().deviceType === 2 ? 'com.haima.cloudphone.game' : 'com.haima.cloudphone.phone',
        accessKeyId: response.result.accessKeyId,
        deviceType
      }
      window.localStorage.setItem('cloudDevicePlayInfo', JSON.stringify(this.cloudDevicePlayInfo))
      router.push({path: 'devicePlay'})
      return false
    }

  }

  // 设备列表滑动
  @action.bound swiperOnChange(activeIndex: number) {
    this.activeIndex = activeIndex
  }

  // 获取当前设备数据
  @action.bound getActiveData() {
    if(!this.cloudDeviceList) return {}
    if(this.activeIndex === this.cloudDeviceList.length)return {}
    return this.cloudDeviceList[this.activeIndex]
  }

  // 设备重命名
  @action.bound async cloudDeviceRename() {
    if(this.renameText.length > 20) {
      GlobalStore.toast.text('输入名字过长!')
      return
    }
    await log.logRequest({eventId: 'H030'})
    GlobalStore.toast.text('正在修改')
    this.setModalState(ModalStateName.renameModalState, false)
    const {id} = this.getActiveData()
    const response = await cloudDeviceRename({userItemId: id, name: this.renameText})
    this.renameText = ''
    if(response.code === 10000) {
      GlobalStore.toast.text(response.msg)
      await this.getCloudDeviceList()
      return false
    }
    GlobalStore.toast.text(response.msg)
  }

  // 云设备重启
  @action.bound async cloudDeviceReboot() {
    const {remainTime} = this.getActiveData()
    if(remainTime < 60) {
      GlobalStore.toast.text('设备已停用')
      return
    }
    await log.logRequest({eventId: 'H004'})
    GlobalStore.toast.text('正在重启')
    this.setModalState(ModalStateName.restartModalState, false)
    const {cid} = this.getActiveData()
    const response = await cloudDeviceReboot({cid})

    if(response.code === 10000) {
      //GlobalStore.toast.text('重启成功')
      await this.getCloudDeviceList()
      return false
    }
    GlobalStore.toast.text(response.msg)
  }

  // 云设备恢复出厂
  @action.bound async cloudDeviceReset() {
    const {remainTime} = this.getActiveData()
    if(remainTime < 60) {
      GlobalStore.toast.text('设备已停用')
      return
    }
    await log.logRequest({eventId: 'H024'})
    GlobalStore.toast.text('正在恢复出厂')
    this.setModalState(ModalStateName.restoreModalState, false)
    const {cid} = this.getActiveData()
    const response = await cloudDeviceReset({cid})
    if(response.code === 10000) {
      await this.getCloudDeviceList()
      //GlobalStore.toast.text('恢复出厂成功')
      return false
    }
    GlobalStore.toast.text(response.msg)
  }

  // 云设备刷新
  @action.bound async cloudDeviceRefresh() {
    const {cid} = this.getActiveData()
    const index = this.cloudDeviceList.map(r => r.cid).indexOf(cid);
    this.cloudDeviceList[index].refreshStatus = true;
    const response = await cloudDeviceRefresh({cid});
    //this.cloudDeviceList[index].refreshStatus = false;
    if(response.code === 10000) {
      GlobalStore.toast.text(response.msg)
    }
  }

  //重命名输入
  @action.bound renameInputOnChange(e: any) {
    this.renameText = e.target.value
  }

  // 跳转资费
  @action.bound routerPushPackage(params: any) {
    let routerName: string;
    if(params === null) {
      window.localStorage.removeItem('packageInfo')
      routerName = 'package?type=0'
    } else {
      console.log(params.id);
      routerName = 'package?type=1&deviceType=' + params.category + '&id=' + params.id
      window.localStorage.setItem('packageInfo', JSON.stringify(params))
    }
    router.push({path: routerName, params})
  }

}

export default new HomeStore();
